import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    mixins: [emCommonUtilMixin],
    props: {
        action: {
            type: String,
            required: true
        },
        accept: String,
        multiple: {
            type: Boolean,
            default: false
        },
        putBeforeUpload: {
            type: Function,
            default: () => {
            }
        },
        appendMode: {
            type: Boolean,
            default: false
        },
        paramName: {
            type: String,
            default: 'file'
        },
    },
    data() {
        return {
            fileList: [],
            loading: false,

            allFiles: {},
            submitted: false,
            changeFlag: new Date(),
        }
    },
    computed: {
        finalFileList() {
            if (this.changeFlag) {
                //
            }
            if (this.multiple && this.appendMode) {
                return Object.values(this.allFiles);
            } else {
                return this.fileList;
            }
        },
    },
    watch: {
        fileList: {
            handler() {
                this.fileListChange();
            },
            deep: true
        }
    },
    methods: {
        fileListChange() {
            let nameList = [];
            if (this.multiple && this.appendMode) {
                if (this.submitted) {
                    this.submitted = false;
                    this.allFiles = {};
                }
                for (let item of this.fileList) {
                    let fileName = item.name;
                    nameList.push(fileName);
                    this.allFiles[fileName] = item;
                }
                this.changeFlag = new Date();
            } else {
                for (let item of this.fileList) {
                    nameList.push(item.name);
                }
            }
            console.log(this.fileList);
            this.$emit('fileChange', nameList);
        },
        submitUpload(noWarn = false, file = null) {
            this.loading = true;
            let param = new FormData();
            if (file != null) {
                param.append(this.paramName, file);
            } else {
                if (this.multiple) {
                    for (let item of this.finalFileList) {
                        param.append(this.paramName, item);
                    }
                } else {
                    param.append(this.paramName, this.fileList);
                }
            }
            if (param.getAll(this.paramName).length === 0) {
                if (!noWarn) {
                    this.$message.warning('No file chosen');
                }
                this.$emit('finish');
                this.loading = false;
                return;
            }
            this.putBeforeUpload(param);
            this.$store.dispatch('api/postMultipart', {
                url: this.action,
                data: param
            }).then(response => {
                this.whenSuccess(response);
                this.submitted = true;
            }).finally(() => {
                this.loading = false;
                this.$emit('finish');
            });
        },

        removeFile(name) {
            if (this.appendMode && this.allFiles[name]) {
                this.$delete(this.allFiles, name);
                this.$emit('fileRemove', name);
            }
        },

        whenSuccess(response) {
            this.$emit('success', response);
        },
    },
}
